module.exports = __webpack_public_path__ + "teqbahn-assets/media/27.029082b0.jpg";